<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="550px" :before-close="handleClose">
    <!-- <el-checkbox-group v-model="checkList">
      <el-checkbox :label="item.exhibitionHallId" v-for="item in checkLabel">
        <div>{{item.exhibitionHallName}}</div>
        <div class="fontcolor-grey">{{item.exhibitionTypeName}}</div>
      </el-checkbox>
    </el-checkbox-group> -->
    <template v-if="checkLabel.length==0">
      <div class="no-data">
        <img src="@images/none.png" />
        <div>暂无数据</div>
      </div>
    </template>
    <template v-else>
      <el-radio-group v-model="radio">
        <el-radio :label="item.exhibitionHallId" v-for="item in checkLabel" :disabled="item.isApplied==1">
          <div class="font16">{{item.exhibitionHallName}}</div>
          <div class="fontcolor-grey">{{item.exhibitionTypeName}}</div>
          <div class="status" v-if="item.isApplied==1">已申请</div>
        </el-radio>
      </el-radio-group>
    </template>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitDialog" size="small" v-if="checkLabel.length!==0">确 定</el-button>
      <el-button @click="closeDialog" size="small" plain>取 消</el-button>

    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    dialogVisible: {
      //弹窗组件是否显示 默认不显示
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      //弹窗标题
      type: String,
      default: '标题',
      required: true,
    },
  },
  data() {
    return {
      checkList: [],
      checkLabel: [],
      radio: "",
      userMess: this.$store.state.user.user,
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleClose(done) {
      this.radio = ""
      this.$emit("on-close");
    },
    submitDialog() {
      if (this.radio == "") {

        this.$message.error('请选择需要解锁的展厅');
      } else {
        this.getList()
        this.$emit("on-submit", this.radio);
        this.$emit("on-close");
        this.radio = ""
      }

    },
    closeDialog() {
      this.$emit("on-close");
      this.radio = ""
    },
    getList() {
      this.$api.getHallList({ volunteerId: this.userMess.id }).then(res => {
        // console.log(res.data)
        this.checkLabel = res.data
      })

    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "~@/components/modal/modal.less";
/deep/.el-checkbox__input {
  margin-top: 3px;
  vertical-align: top;
}
/deep/.el-dialog__body {
  max-height: 475px;
  overflow: auto;
}
/deep/ .el-radio {
  display: flex;
  margin: 8px 0;
}
.fontcolor-grey {
  line-height: 30px;
}
.status {
  position: absolute;
  top: 10px;
  right: 0;
  background-color: #c6c6c6;
  color: #fff;
  padding: 6px 20px;
}
.el-radio-group {
  width: 460px;
}
.font16 {
  font-size: 16px;
}
</style>
